import React from 'react';
import upArrow from '../images/up-arrow.png';

const BackToTop = () => {
  return (
    <div className='back-to-top'>
      <a href="#">  <img src={upArrow} alt="up-arrow" /></a>
    </div>
  )
}

export default BackToTop